export const taxSubjectsDE = [
    'Ledig, 0 Kinder',
    'Ledig, 1 Kind',
    'Ledig, 2 Kinder',
    'Ledig, 3 Kinder',
    'Verh. ein Einkommen, 0 Kinder',
    'Verh. ein Einkommen, 1 Kind',
    'Verh. ein Einkommen, 2 Kinder',
    'Verh. ein Einkommen, 3 Kinder',
    'Verh. zwei Einkommen (70/30), 0 Kinder',
    'Verh. zwei Einkommen (70/30), 1 Kind',
    'Verh. zwei Einkommen (70/30), 2 Kinder',
    'Verh. zwei Einkommen (70/30), 3 Kinder',
    'Verh. zwei Einkommen (50/50), 0 Kinder',
    'Verh. zwei Einkommen (50/50), 1 Kind',
    'Verh. zwei Einkommen (50/50), 2 Kinder',
    'Verh. zwei Einkommen (50/50), 3 Kinder',
    'Rentner:in, ledig',
    'Verh. eine Rente',
    'Verh. zwei Renten (70/30)',
    'Verh. zwei Renten (50/50)'
  ]
  export const availableIncomeDE = [
    { text: "15'000", value: 15000 },
    { text: "20'000", value: 20000 },
    { text: "25'000", value: 25000 },
    { text: "30'000", value: 30000 },
    { text: "35'000", value: 35000 },
    { text: "40'000", value: 40000 },
    { text: "45'000", value: 45000 },
    { text: "50'000", value: 50000 },
    { text: "60'000", value: 60000 },
    { text: "70'000", value: 70000 },
    { text: "80'000", value: 80000 },
    { text: "90'000", value: 90000 },
    { text: "100'000", value: 100000 },
    { text: "125'000", value: 125000 },
    { text: "150'000", value: 150000 },
    { text: "175'000", value: 175000 },
    { text: "200'000", value: 200000 },
    { text: "250'000", value: 250000 },
    { text: "300'000", value: 300000 },
    { text: "400'000", value: 400000 },
    { text: "500'000", value: 500000 },
    { text: "750'000", value: 750000 },
    { text: '1 Million', value: 1000000 },
    { text: '5 Millionen', value: 5000000 },
    { text: '10 Millionen', value: 10000000 },
    { text: '50 Millionen', value: 50000000 },
    { text: '100 Millionen', value: 100000000 }
  ]
  export const taxSubjectsFR = [
    'Célibataire, 0 enfants',
    'Célibataire, 1 enfant',
    'Célibataire, 2 enfants',
    'Célibataire, 3 enfants',
    'Marié·e, un revenu, 0 enfants',
    'Marié·e, un revenu, 1 enfant',
    'Marié·e, un revenu, 2 enfants',
    'Marié·e, un revenu, 3 enfants',
    'Marié·e, deux revenus (70/30), 0 enfants',
    'Marié·e, deux revenus (70/30), 1 enfant',
    'Marié·e, deux revenus (70/30), 2 enfants',
    'Marié·e, deux revenus (70/30), 3 enfants',
    'Marié·e, deux revenus (50/50), 0 enfants',
    'Marié·e, deux revenus (50/50), 1 enfant',
    'Marié·e, deux revenus (50/50), 2 enfants',
    'Marié·e, deux revenus (50/50), 3 enfants',
    'Retraité·e, célibataire',
    'Marié·e, une retraite',
    'Marié·e, deux retraites (70/30)',
    'Marié·e, deux retraites (50/50)'
  ]
  export const availableIncomeFR = [
    { text: "15'000", value: 15000 },
    { text: "20'000", value: 20000 },
    { text: "25'000", value: 25000 },
    { text: "30'000", value: 30000 },
    { text: "35'000", value: 35000 },
    { text: "40'000", value: 40000 },
    { text: "45'000", value: 45000 },
    { text: "50'000", value: 50000 },
    { text: "60'000", value: 60000 },
    { text: "70'000", value: 70000 },
    { text: "80'000", value: 80000 },
    { text: "90'000", value: 90000 },
    { text: "100'000", value: 100000 },
    { text: "125'000", value: 125000 },
    { text: "150'000", value: 150000 },
    { text: "175'000", value: 175000 },
    { text: "200'000", value: 200000 },
    { text: "250'000", value: 250000 },
    { text: "300'000", value: 300000 },
    { text: "400'000", value: 400000 },
    { text: "500'000", value: 500000 },
    { text: "750'000", value: 750000 },
    { text: '1 Million', value: 1000000 },
    { text: '5 Millions', value: 5000000 },
    { text: '10 Millions', value: 10000000 },
    { text: '50 Millions', value: 50000000 },
    { text: '100 Millions', value: 100000000 }
  ]